import { createContext, useState, useCallback, useRef } from 'react'

// eslint-disable-next-line react-refresh/only-export-components -- context colocated with its provider; consumers use the useToast hook
export const ToastContext = createContext(null)

let _id = 0

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])
  const timers = useRef({})

  const dismiss = useCallback((id) => {
    clearTimeout(timers.current[id])
    delete timers.current[id]
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  const addToast = useCallback((message, type = 'info', duration = 4500) => {
    const id = ++_id
    // Cap the visible stack at 5
    setToasts(prev => [...prev.slice(-4), { id, message, type }])
    timers.current[id] = setTimeout(() => dismiss(id), duration)
    return id
  }, [dismiss])

  const showError   = useCallback((msg) => addToast(msg, 'error'),   [addToast])
  const showSuccess = useCallback((msg) => addToast(msg, 'success'), [addToast])
  const showInfo    = useCallback((msg) => addToast(msg, 'info'),    [addToast])

  return (
    <ToastContext.Provider value={{ toasts, addToast, showError, showSuccess, showInfo, dismiss }}>
      {children}
    </ToastContext.Provider>
  )
}
